document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open) setCartOpen(false);
    });
  }

  const navDetails = [...document.querySelectorAll('.primary-nav .nav-menu-item')];
  const precisePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const closeTimers = new WeakMap();
  navDetails.forEach((details) => {
    details.addEventListener('pointerenter', () => {
      if (!precisePointer.matches) return;
      window.clearTimeout(closeTimers.get(details));
      navDetails.forEach((item) => { if (item !== details) item.open = false; });
      details.open = true;
    });
    details.addEventListener('pointerleave', () => {
      if (!precisePointer.matches) return;
      closeTimers.set(details, window.setTimeout(() => { details.open = false; }, 140));
    });
  });

  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartCount = document.querySelector('[data-cart-count]');
  const cartTotal = document.querySelector('[data-cart-total]');

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[character]);
  const money = (cents) => new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'COP',
    maximumFractionDigits: 0
  }).format((Number(cents) || 0) / 100);

  const renderCart = (cart) => {
    if (!cartItems) return;
    if (cartCount) cartCount.textContent = cart.item_count;
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (cartFooter) cartFooter.hidden = cart.item_count === 0;

    if (!cart.items.length) {
      cartItems.innerHTML = '<p class="header-cart__status">Tu carrito está vacío. Explora el catálogo para encontrar el equipo ideal.</p>';
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => `
      <article class="header-cart__item">
        <a href="${escapeHtml(item.url)}" tabindex="-1"><img src="${escapeHtml(item.image)}" alt="" width="58" height="58"></a>
        <div class="header-cart__item-info">
          <a href="${escapeHtml(item.url)}"><h3>${escapeHtml(item.product_title)}</h3></a>
          <strong>${money(item.final_line_price)}</strong>
          <div class="header-cart__quantity" aria-label="Cantidad de ${escapeHtml(item.product_title)}">
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Disminuir cantidad">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad">+</button>
          </div>
        </div>
        <button class="header-cart__remove" type="button" data-cart-change data-line="${index + 1}" data-quantity="0" aria-label="Eliminar ${escapeHtml(item.product_title)}">
          <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 6h18M8 6V4h8v2m3 0-1 15H6L5 6m5 4v7m4-7v7"/></svg>
        </button>
      </article>
    `).join('');
  };

  const changeCartItem = async (line, quantity, button) => {
    if (!cartItems) return;
    cartItems.querySelectorAll('[data-cart-change]').forEach((control) => { control.disabled = true; });
    button?.classList.add('is-loading');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error('No fue posible actualizar el carrito');
      renderCart(await response.json());
    } catch (error) {
      await loadCart();
    }
  };

  const loadCart = async () => {
    if (!cartItems) return;
    cartItems.innerHTML = '<p class="header-cart__status">Actualizando carrito…</p>';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No fue posible consultar el carrito');
      renderCart(await response.json());
    } catch (error) {
      cartItems.innerHTML = '<p class="header-cart__status">No pudimos actualizar el resumen. Abre el carrito para continuar.</p>';
      if (cartFooter) cartFooter.hidden = false;
    }
  };

  const setCartOpen = (open) => {
    if (!cartDrawer || !cartToggle) return;
    cartDrawer.classList.toggle('is-open', open);
    cartOverlay?.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', String(!open));
    cartToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('cart-open', open);
    if (open) {
      nav?.classList.remove('is-open');
      menuButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      navDetails.forEach((details) => { details.open = false; });
      loadCart();
    }
  };

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', (event) => {
      event.preventDefault();
      setCartOpen(!cartDrawer.classList.contains('is-open'));
    });
    cartClose?.addEventListener('click', () => setCartOpen(false));
    cartOverlay?.addEventListener('click', () => setCartOpen(false));
    cartItems?.addEventListener('click', (event) => {
      const control = event.target.closest('[data-cart-change]');
      if (!control || control.disabled) return;
      changeCartItem(Number(control.dataset.line), Number(control.dataset.quantity), control);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        setCartOpen(false);
        cartToggle.focus();
      }
    });
  }

  const hero = document.querySelector('[data-hero]');
  if (!hero) return;
  const slides = [...hero.querySelectorAll('[data-slide]')];
  const buttons = [...hero.querySelectorAll('[data-slide-button]')];
  let current = 0;
  let timer;
  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
    buttons.forEach((button, i) => button.classList.toggle('is-active', i === current));
  };
  const play = () => {
    window.clearInterval(timer);
    if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(() => show(current + 1), 6500);
    }
  };
  buttons.forEach((button, index) => button.addEventListener('click', () => { show(index); play(); }));
  show(0);
  play();
});
